// origin will look like this: https://appmanager-dev.gfi.com, we need to add .api to the start of the string
export const BASE_URL = window.location.origin.includes('localhost') ? 'https://api.appmanager-dev.gfi.com' : window.location.origin.replace('https://', 'https://api.');

export const FRONTEND_BASE_URL = window.location.origin.includes('localhost') ? 'https://appmanager-dev.gfi.com' : window.location.origin;

// Sales contact email for trial/license inquiries
export const SALES_EMAIL = process.env.REACT_APP_SALES_EMAIL || 'sales@gfi.com';